import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import * as styles from './style.module.scss';
import PostAuthorHead from './postAuthorHead';

const { postAuthor, postAuthor__description } = styles;

const PostAuthor = ({ author, content }) => {
  const richText = JSON.parse(content.raw);
  const renderRichText = () => {
    if (richText) {
      return documentToReactComponents(richText);
    }
    return null;
  };

  return (
    <section className={postAuthor} id="post-author">
      <PostAuthorHead author={author} />
      <div className={postAuthor__description}>{renderRichText()}</div>
    </section>
  );
};

export default PostAuthor;
